import * as React from "react";
import Select from "react-select";

const ShippingInfoBox = ({ countries, shippingMethods, shippingRates }) => {
  const [selected, setSelected] = React.useState(null);
  const [shippingInfo, setShippingInfo] = React.useState(null);

  React.useEffect(() => {
    if (selected) {
      const {
        shipping_method: shipping_method_id,
        country_excluded_items,
        shipping_zone: shipping_zone_ids,
      } = findCountry(selected.value);

      const shipping_method = findShippingMethod(shipping_method_id);

      // initialize shipping method display name
      let shipping_method_display_name;

      // add shipping level info
      let excluded = "";
      if (shipping_method) {
        const { shipping_excluded_items, display_name } = shipping_method;
        if (shipping_excluded_items.length) excluded += shipping_excluded_items;
        if (display_name) shipping_method_display_name = display_name;
      }

      // add country level info
      if (country_excluded_items.length) {
        if (excluded.length) excluded += ", ";
        excluded += country_excluded_items;
      }

      // reset excluded items to null if no exclusions
      if (excluded.length === 0) excluded = null;

      // get shipping zone info
      if (shippingRates.length) {
      }

      const shippingZone = findShippingZone(shipping_zone_ids[0]);
      const { shipping_zone_rates_sample_rates } = shippingZone;
      const sampleRates = shipping_zone_rates_sample_rates || null;

      setShippingInfo({
        shippingMethodDisplay: shipping_method_display_name,
        excludedItems: excluded,
        sampleRates,
      });
    }
  }, [selected]);

  const findCountry = (countryName) => {
    return countries.find((c) => c.country === countryName);
  };

  const findShippingMethod = (recordId) => {
    return shippingMethods.find(
      (s) => s.shipping_method_record_id === recordId
    );
  };

  const findShippingZone = (recordId) => {
    return shippingRates.find(
      (s) => s.shipping_zone_rates_record_id === recordId
    );
  };

  const countryOptions = countries.map(({ country }) => ({
    value: country,
    label: country,
  }));

  const handleChange = (selectedCountry) => {
    setSelected(selectedCountry);
  };

  return (
    <div className="c-shipping-info-box">
      <h2>Shipping Information by Country</h2>
      <Select
        value={selected}
        onChange={handleChange}
        options={countryOptions}
        placeholder="Select country..."
      />
      {shippingInfo && (
        <div className="c-shipping-info-box-text">
          {shippingInfo.shippingMethodDisplay && (
            <p>
              <strong>Shipping method:</strong>{" "}
              {shippingInfo.shippingMethodDisplay}
            </p>
          )}
          {shippingInfo.excludedItems && (
            <p>
              <strong>Excluded items:</strong> {shippingInfo.excludedItems}
            </p>
          )}
          {shippingInfo.sampleRates && (
            <p>
              <strong>Sample shipping rates:</strong> {shippingInfo.sampleRates}
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ShippingInfoBox;
